import React from "react"
import BigCalendar from "react-big-calendar"

const convertDateTimeStringToDate = (datetime, timeZoneName) => {
  const m = timeZoneName ? moment.tz(datetime, timeZoneName) : moment.parseZone(datetime)
  return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute(), 0)
}

const convertDateToDateTimeString = (date, timeZoneName) => {
  const dateM = moment.tz(date, BigCalendar.tz)
  const m = moment.tz({
    year: dateM.year(),
    month: dateM.month(),
    date: dateM.date(),
    hour: dateM.hour(),
    minute: dateM.minute(),
  }, BigCalendar.tz)
  return m
}

export default function withTimezoneAwareness(Calendar) {
  return ({ timeZoneName, ...props }) => {
    return React.createElement(Calendar, {
      ...props,

      events: props.events && props.events.map(event => ({
        ...event,
        start: event.start && convertDateTimeStringToDate(event.start, timeZoneName),
        end: event.end && convertDateTimeStringToDate(event.end, timeZoneName),
      })),
      
      onSelectSlot: props.onSelectSlot && (({ start, end, slots }) => (
        props.onSelectSlot({
          start: convertDateToDateTimeString(start, timeZoneName),
          end: convertDateToDateTimeString(end, timeZoneName),
          slots: slots.map(date => convertDateToDateTimeString(date, timeZoneName)),
        })
      )),

      onEventDrop: props.onEventDrop && (({ event, start, end }) => (
        props.onEventDrop({
          event,
          start: convertDateToDateTimeString(start, timeZoneName),
          end: convertDateToDateTimeString(end, timeZoneName),
        })
      )),
    })
  }
}


// WEBPACK FOOTER //
// ./app/webpack/frontend/lib/react-big-calendar/withTimezoneAwareness.js